import React from "react";
import DELogo from "./assets/DE_logo.png";

const tags = [
  "Social Media",
  "Software Development",
  "Customer Service",
  "Medical Billing",
  "Telecom",
  "Logistics",
];

const DigitalElitesCard = () => {
  return (
    <div className="w-full max-w-6xl mx-auto px-4 my-16">
      <div className="bg-white rounded-2xl shadow-md px-10 py-10 flex flex-col gap-6">
        {/* Logo */}
        <div>
          <img
            src={DELogo}
            alt="Digital Elites Global"
            className="h-12 w-auto object-contain"
          />
        </div>

        {/* Heading + Button */}
        <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-6">
          <h2 className="text-3xl md:text-4xl font-bold text-black leading-tight max-w-xl">
            Beyond the gym, {" "}
            <span className="text-gray-300">I help bussiness grow digitally.</span>
          </h2>
          <a
            href="https://digitalelites.global/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white font-semibold px-6 py-3 rounded-lg transition-all duration-200 whitespace-nowrap self-start lg:self-auto"
          >
            Visit the site
            <span className="text-lg">→</span>
          </a>
        </div>

        {/* Tags */}
        <div className="flex flex-wrap gap-2">
          {tags.map((tag) => (
            <span
              key={tag}
              className="border border-gray-300 text-gray-600 text-sm px-4 py-1.5 rounded-full"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DigitalElitesCard;
